import React, { useState } from 'react'
import { Alert, AlertTitle, Stack, Typography } from '@mui/material'
import { logOut } from '../services/api'
import { logIn } from '../services/LoginService'
import { FormattedMessage } from 'react-intl'
import { useInnsynContext } from '../context/InnsynContextProvider'

interface Props {
    iconLeft: React.ReactNode | null
    chosen: boolean
    header: string | JSX.Element
    content: string | JSX.Element
    bruker: boolean
    isLoggedIn?: boolean
    openDialogFunction: Function
}

const HeaderText = ({
                        iconLeft,
                        chosen,
                        header,
                        content,
                        bruker = false,
                        isLoggedIn,
                        openDialogFunction
                    }: Props) => {
    const [showOfflineAlert, setShowOfflineAlert] = useState(false)
    const { fetchBruker, konfigurasjon } = useInnsynContext()
    return (
        <>
            {showOfflineAlert && (
                <Alert
                    onClose={() => {
                        setShowOfflineAlert(false)
                    }}
                    severity='info'
                    sx={{
                        marginBottom: '2rem',
                        position: 'absolute',
                        right: '2rem',
                        left: '2rem',
                        top: '5rem'
                    }}>
                    <AlertTitle>
                        <FormattedMessage id='log-in.alert-no-internet-header'/>
                    </AlertTitle>
                    <FormattedMessage id='log-in.alert-no-internet'/>
                </Alert>
            )}
            {konfigurasjon &&
                <Stack
                    sx={{
                        textDecoration:
                            bruker && iconLeft && isLoggedIn
                                ? 'none'
                                : 'underline solid white',
                        '&:hover': {
                            outline:
                                bruker && iconLeft && isLoggedIn
                                    ? 'none'
                                    : '3px solid white',
                            width: 'fit-content'
                        }
                    }}
                    direction='row'
                    onClick={() => {
                        if (isLoggedIn && bruker && !iconLeft) {
                            logOut(() => fetchBruker())
                            openDialogFunction(false)
                        }
                        if (!isLoggedIn && bruker && iconLeft) {
                            openDialogFunction(true)
                            if (navigator.onLine) {
                                logIn(konfigurasjon?.altinnUrl)
                            } else {
                                setShowOfflineAlert(true)
                            }
                        }
                        if (!bruker) {
                            openDialogFunction(false)
                        }
                    }}>
                    {chosen && iconLeft}
                    <Typography sx={{ fontWeight: chosen ? '400' : '300' }}>
                        {header}
                    </Typography>
                </Stack>}
            <Typography
                sx={{
                    marginTop: bruker && iconLeft ? '-0.5rem' : '0.5rem',
                    fontWeight: '300',
                    marginBottom: '3rem'
                }}>
                {content}
            </Typography>
        </>
    )
}
export default HeaderText
